export enum BANK_TRANSACTION_STATUS {
  PROCESSING = 0,
  PROCESSED = 1,
  FAILED = 2,
  ON_HOLD = 3
};
